import { ocapiV1Routes } from '../routes';
export const journeysApiRoutes = {
    getById: (journeyId)=>`${ocapiV1Routes.journeys}/${journeyId}`
    ,
    getByReference: (journeyReference)=>`${ocapiV1Routes.journeys}/by-reference/${journeyReference}`
    ,
    getForCompletedOrder: (orderId)=>`${ocapiV1Routes.journeys}/by-order-id/${orderId}`
    ,
    thirdPartyPasses: {
        getAppleWalletPass: (journeyId)=>`${ocapiV1Routes.journeys}/${journeyId}/third-party-passes/apple-wallet`
        ,
        getGooglePayPass: (journeyId)=>`${ocapiV1Routes.journeys}/${journeyId}/third-party-passes/google-pay`
    }
};

//# sourceMappingURL=routes.js.map